import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// F-MOTOR-RESERVAS.3.1.5.1 — pré-reservas do site pendentes (origem=site, status=pre-reserva)
export const PRE_RESERVAS_SITE_URL = "/admin/reservas?origem=site&status=pre-reserva";

export function usePreReservasSite(enabled) {
  const location = useLocation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) { return undefined; }
    let alive = true;
    const fetchCount = () => {
      api.get("/reservas", { params: { origem: "site", status: "pre-reserva" } })
        .then((r) => { if (alive) setCount(Array.isArray(r.data) ? r.data.length : 0); })
        .catch(() => {});
    };
    fetchCount();
    const t = setInterval(fetchCount, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [enabled, location.pathname, location.search]);
  return count;
}
